import api from "app/api";
import { Options } from "common";

export interface EmailTemplateItem {
  id: number;
  name: string;
  subject: string;
  body: string;
  description: string | null;
  is_active: boolean;
}

export type EmailTemplateOptions = Options<"status">;

export function getEmailTemplateService(scope?: any) {
  return api.getService<
    EmailTemplateItem,
    EmailTemplateItem,
    EmailTemplateOptions
  >("email-templates", {
    scope,
  });
}
